<template>
  <div class="form-card">
    <div class="form-card__header">
      <div class="form-card__header-icon"><i class="pi pi-money-bill"></i></div>
      <div>
        <p class="form-card__title">{{ singlePrice ? 'سعر الكورس' : 'الأسعار والخطط' }}</p>
        <p class="form-card__subtitle">
          {{ singlePrice ? 'سعر شراء لمرة واحدة يمنح الطالب وصولاً مدى الحياة (لا يوجد تاريخ انتهاء)' : 'اترك الحقل فارغاً لتعطيل تلك الخطة' }}
        </p>
      </div>
    </div>
    <div class="form-card__body">
      <!-- COURSE: one lifetime price only -->
      <div v-if="singlePrice" class="ds-field-grid">
        <div class="form-field ds-field--full">
          <label class="field-label">سعر الكورس</label>
          <input type="number" class="form-control" v-model="form.price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
      </div>

      <!-- ACADEMIC YEAR: time-limited monthly / term / yearly plans (unchanged) -->
      <div v-else class="ds-field-grid ds-field-grid--4">
        <div class="form-field">
          <label class="field-label">سعر الشهر</label>
          <input type="number" class="form-control" v-model="form.monthly_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">سعر الترم الأول</label>
          <input type="number" class="form-control" v-model="form.term1_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">سعر الترم الثاني</label>
          <input type="number" class="form-control" v-model="form.term2_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">السعر السنوي</label>
          <input type="number" class="form-control" v-model="form.yearly_price" min="0" step="0.01" placeholder="0.00" dir="ltr" />
        </div>
        <div class="form-field">
          <label class="field-label">نهاية الترم الأول <span class="optional">اختياري</span></label>
          <input type="date" class="form-control" v-model="form.term1_end_date" />
        </div>
        <div class="form-field">
          <label class="field-label">نهاية الترم الثاني <span class="optional">اختياري</span></label>
          <input type="date" class="form-control" v-model="form.term2_end_date" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Shared "Pricing" product-editor section. `form` is the parent's reactive form object
// passed by reference — mutating its fields here stays in sync with the parent without
// emit boilerplate (same convention as the rest of this admin panel's form components).
//
// singlePrice=true → Courses: a single lifetime `price` (one-time purchase, never
// expires). singlePrice=false (default) → Academic Years: the time-limited
// monthly/term/yearly plans, unchanged.
export default {
  name: 'ProductPricingSection',
  props: {
    form: { type: Object, required: true },
    singlePrice: { type: Boolean, default: false },
  },
};
</script>
